<template>
  <card>
    <el-collapse v-model="activeName" @change="handleCollapse">
      <el-collapse-item :title="titleFilter" name="filter">
        <filter-component
          :isRequiredFarms="false"
          :filterOfLots="false"
          @filter="handleFilter"
          @showHideLoading="showHideLoading"
          @onFarmChange="handleFarmChange"
          classFarms="col-lg-6"
          ref="filters"
        >
          <template slot="prev">
            <div
              :class="`col-12 col-sm-12 col-md-6 ${
                showHourType ? 'col-lg-4' : ''
              } pt-3`"
            >
              <label for="">{{ $t('common_words.activities') }}: </label>
              <br />
              <el-select
                @change="
                  selectAllFromSelect('dataFilter.activities', activities)
                "
                clearable
                collapse-tags
                style="width: 100%"
                multiple
                filterable
                class="select-primary custom-width-select shadow-sm"
                v-model="dataFilter.activities"
                :placeholder="`${$t('common_words.select2')}...`"
              >
                <el-option
                  class="select-primary selected-all"
                  v-for="(item, index) in activities"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div
              :class="`col-12 col-sm-12 col-md-6 ${
                showHourType ? 'col-lg-4' : ''
              } pt-3`"
            >
              <label for="">{{ $t('labor.workers') }}: </label>
              <br />
              <el-select
                @change="selectAllFromSelect('dataFilter.workers', getWorkers)"
                clearable
                collapse-tags
                style="width: 100%"
                multiple
                filterable
                class="select-primary custom-width-select shadow-sm"
                v-model="dataFilter.workers"
                :placeholder="`${$t('common_words.select2')}...`"
              >
                <el-option
                  class="select-primary selected-all"
                  v-for="(item, index) in getWorkers"
                  :key="index"
                  :label="`${item.name}`"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div
              class="col-12 col-sm-12 col-md-6 col-lg-4 pt-3"
              v-if="showHourType"
            >
              <label for="">{{ $t('labor.hour_type') }}: </label>
              <br />
              <el-select
                @change="selectAllFromSelect('dataFilter.timeTypes', timeTypes)"
                clearable
                collapse-tags
                style="width: 100%"
                multiple
                filterable
                class="select-primary custom-width-select shadow-sm"
                v-model="dataFilter.timeTypes"
                :placeholder="`${$t('common_words.select2')}...`"
              >
                <el-option
                  class="select-primary selected-all"
                  v-for="(item, index) in timeTypes"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </template>
        </filter-component>
      </el-collapse-item>
    </el-collapse>
  </card>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import Filter from 'src/components/Filter/Filters.vue';
import MixinForm from 'src/mixins/forms/mixin-form.js';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';

export default {
  name: 'card-filter',
  components: {
    [Filter.name]: Filter,
  },
  props: {
    showHourType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeName: 'filter',
      activities: [],
      workers: [],
      timeTypes: [],
      valueCollapse: null,
      dataFilter: {
        datef: moment().format('YYYY-MM-DD'),
        datei: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        labors: [],
        farm: [],
        lot: [],
        timeTypes: [],
        activities: [],
        workers: [],
      },
    };
  },
  mixins: [MixinForm, MixinPermissions],
  computed: {
    getWorkers() {
      if (this.dataFilter.farm.length > 0) {
        return this.concatAll(
          this.workers.filter((worker) =>
            this.dataFilter.farm.includes(worker.farm_id)
          )
        );
      }

      return this.concatAll(this.workers);
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
  },
  methods: {
    handleFarmChange(dataChange) {
      this.dataFilter.farm = dataChange.farm_ids;
      const workersSelected = [...this.dataFilter.workers];
      this.$set(this.dataFilter, 'workers', []);

      const wid = this.getWorkers.map((worker) => worker.id);
      const widResult = workersSelected.filter((workerId) => wid.includes(workerId));
      this.$set(this.dataFilter, 'workers', widResult);
    },
    getSelectAll() {
      this.workers = this.concatAll(this.workers.splice(1));
      this.activities = this.concatAll(this.activities.splice(1));
      if (this.showHourType)
        this.timeTypes = this.concatAll(this.timeTypes.splice(1));
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    handleFilter(data) {
      this.$emit('filter', { ...this.dataFilter, ...data });
    },
    showHideLoading(option = false) {
      this.$emit('showHideLoading', option);
    },
  },
  created() {
    if (this.isIndex()) {
      this.$emit('setupTable');
      Axios.getMasters('works/workers/indexField').then((response_workers) => {
        this.workers = response_workers.data.data;
        this.showHideLoading();
      });

      Axios.getMasters('works/activities/only/field').then(
        (response_activities) => {
          this.activities = this.concatAll(response_activities.data.data);
          this.showHideLoading();
        }
      );

      if (this.showHourType) {
        Axios.getMasters('works/timetypes/field').then(
          (response_time_types) => {
            this.timeTypes = this.concatAll(response_time_types.data.data);
            this.showHideLoading();
          }
        );
      }
    } else {
      this.showMessageAccess();
    }
  },
};
</script>
